<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="固件" v-model="name"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="版本号" v-model="version"></el-input>
      </el-col>
      <el-col :span="14">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="2">
        <router-link to="./add">
          <el-button type="success">新增</el-button>
        </router-link>
      </el-col>
    </el-row>

    <el-table :data="data" border stripe style="width: 100%">
      <el-table-column prop="name" label="固件名"> </el-table-column>
      <el-table-column prop="type" label="固件类型"> </el-table-column>
      <el-table-column prop="version" label="版本号"> </el-table-column>
      <el-table-column prop="fileName" label="文件名"> </el-table-column>
      <el-table-column prop="romModel" label="固件名称"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="210">
        <template slot-scope="scope">
          <el-button @click="Edit(scope.$index)" type="text" size="small"
            >编辑</el-button
          >
          <el-button @click="Delete(scope.$index)" type="text" size="small"
            >删除</el-button
          >
          <el-button @click="Level(scope.$index)" type="text" size="small"
            >设备升级</el-button
          >
          <el-button @click="lishi(scope.$index)" type="text" size="small"
            >升级历史</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      name: "",
      version: "",
      data: [],
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      checkArray: [], //check选中
    };
  },
  methods: {
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
      };
      if (this.name.trim() != "") {
        params.name = this.name;
      }
      if (this.version.trim() != "") {
        params.version = this.version;
      }
      this.$http.post("/manage/firm/list", params).then((results) => {
        this.data = results["data"]["data"]["records"];
        this.pagin.total = results["data"]["data"]["total"];
      });
    },
    Edit(index) {
      this.$store.commit("setEditInfo", this.data[index]);
      this.$router.push("./edit/" + this.data[index].id);
    },
    Delete(index) {
      //单删
      if (confirm("确认要删除吗？")) {
        let ID = this.data[index].id;
        this.$http.post("/manage/firm/del", { firmId: ID }).then(() => {
          this.data.splice(index, 1);
        });
      }
    },
    Level(index) {
      this.$router.push("./upgrade/" + this.data[index].id);
    },
    lishi(index) {
      this.$router.push("./list/" + this.data[index].id);
    },
  },
  components: { Pagination },
};
</script>